import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Download } from 'lucide-react';
import api from '../services/api';
import { useToast } from '../hooks/use-toast';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleDownloadCV = () => {
    api.cv.download();
    toast({
      title: 'Download Started',
      description: 'Your CV download has begun.',
    });
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Experience', path: '/experience' },
    { name: 'Education', path: '/education' },
    { name: 'Skills', path: '/skills' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col relative overflow-hidden">
      {/* Decorative Flag Background Design with Real Flag Images */}
      <div className="fixed inset-0 pointer-events-none z-0">
        {/* Brazil Flag */}
        <img 
          src="https://flagcdn.com/w320/br.png" 
          alt="" 
          className="absolute top-20 left-10 w-64 opacity-10 transform -rotate-12"
        />
        
        {/* UK Flag */}
        <img 
          src="https://flagcdn.com/w320/gb.png" 
          alt="" 
          className="absolute top-32 right-20 w-72 opacity-10 transform rotate-8"
        />
        
        {/* USA Flag */}
        <img 
          src="https://flagcdn.com/w320/us.png" 
          alt="" 
          className="absolute bottom-10 left-32 w-64 opacity-10 transform rotate-6"
        />
        
        {/* Canada Flag */}
        <img 
          src="https://flagcdn.com/w320/ca.png" 
          alt="" 
          className="absolute top-1/2 right-10 w-56 opacity-10 transform -rotate-10"
        />
        
        {/* China Flag - centered */}
        <img 
          src="https://flagcdn.com/w320/cn.png" 
          alt="" 
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 opacity-10 transform rotate-3"
        />
      </div>

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-blue-100 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="text-2xl font-bold text-blue-900 hover:text-blue-700 transition-colors">
              Luís Telles
            </Link>
            <nav className="hidden md:flex space-x-8">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`transition-colors duration-200 font-medium ${
                    location.pathname === item.path
                      ? 'text-blue-600'
                      : 'text-gray-700 hover:text-blue-600'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </nav>
            <Button onClick={handleDownloadCV} className="bg-blue-600 hover:bg-blue-700">
              <Download className="w-4 h-4 mr-2" />
              Download CV
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 pt-20 relative z-10">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-auto relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-gray-400">© 2025 Luís Telles. All rights reserved.</p>
            <p className="text-gray-500 text-sm mt-2">Science & STEAM Educator | Educational Administrator</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
